/**
 * @file Shared React component — components/common/CiteModal.tsx.
 */

import React from "react";
import { createPortal } from "react-dom";
import "./ConfirmModal.css";
import "./CiteModal.css";

interface CiteModalProps {
  open: boolean;
  onClose: () => void;
  menuTitle: string;
  description: string;
}

const CiteModal: React.FC<CiteModalProps> = ({
  open,
  onClose,
  menuTitle,
  description,
}) => {
  if (!open) return null;

  const modalContent = (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cite-modal-title"
      onClick={onClose}
    >
      <div
        className="modal-card fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 id="cite-modal-title">{menuTitle}</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div
          className="modal-body cite-modal-body"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );

  return createPortal(modalContent, document.body) ?? null;
};

/** React component — Cite Modal. */
export default CiteModal;
